// extracted by mini-css-extract-plugin
module.exports = {"mainBackground":"Maps_mainBackground__2urhi","mapSize":"Maps_mapSize__1eiEc","mapNameFont":"Maps_mapNameFont__3YeqU","mobileSizing":"Maps_mobileSizing__1l_Uv"};